import { isValidElement, type ReactNode } from "react";

import { EMPTY_VALUE } from "@/lib/format";

/** Label/value pair for read-only detail grids. Elements render as-is; text is styled. */
export function DetailsItem({ label, value }: { label: string; value: ReactNode }) {
  return (
    <div className="inline-flex min-w-0 flex-col gap-0.5">
      <p className="text-muted-foreground text-xs/relaxed">{label}</p>
      {isValidElement(value) ? (
        value
      ) : (
        <p className="text-xs/relaxed font-medium">
          {value === null || value === undefined || value === "" ? EMPTY_VALUE : value}
        </p>
      )}
    </div>
  );
}
